import React from "react";
import { Circle, Text } from "@atoms";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  text: string;
}

// == Constants ============================================================

// == Component ============================================================

const CircleText = ({ text }: IProps) => {
  return (
    <Circle border="silver" data-testid="circle">
      <Text color="primary" fontSize={3}>
        {text}
      </Text>
    </Circle>
  );
};
export default CircleText;

// == Styles ===============================================================
